<template>
  <v-btn
    :color="isSecondary ? 'grey lighten-2' : 'blue'"
    class="elevation-0 custom-btn"
    :class="isSecondary && 'custom-btn-secondary'"
    :disabled="isDisabled"
    @click.stop="$emit('onClick')"
  >
    {{ text }}
    <v-icon small>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'CustomButton',
  props: ['icon', 'text', 'isSecondary', 'isDisabled']
}
</script>

<style scoped lang="scss">
.custom-btn {
  border-radius: 5px;
  color: $bg-primary;
  &-secondary {
    color: $grey-800;
    & > .btn__content {
      flex-direction: row-reverse;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/buttons/CustomButton.vue